import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';

export const GithubButtonSchema = z
  .object({
    url: z.string().nullish(),
    ariaLabel: z.string().nullish(),
    text: z.string().nullish()
  })
  .nullish();

export const GithubButtonsSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.GithubButtons),
  starButton: GithubButtonSchema.nullish(),
  forkButton: GithubButtonSchema.nullish(),
  followButton: GithubButtonSchema.nullish()
});

export type GithubButton = z.infer<typeof GithubButtonSchema>;
export type GithubButtons = z.infer<typeof GithubButtonsSchema>;
